<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'User', apiMethod: 'Users', form: () => import('../forms/UserForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'User Role', apiMethod: 'UserRoles', parentForeignKey: 'userId', form: () => import('../forms/UserRoleForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Excel Imports', value: 'userId', table: () => import('../tables/ExcelImportsTable') },
                    { text: 'Roles', value: 'userId', isCard: true, table: () => import('../tables/UserRolesTable') },
                ],
                mainForm: () => import('../forms/UserForm'),
                claimName: 'Users',
                apiMethod: 'Users',
            }
        }
    };
</script>
